import { c as _c } from "react/compiler-runtime";
import { OrderBy, SolutionSource, calculateDifferencesNight } from "@website/accommodation-ui/helpers";
import { displayPercentageDiscount } from "@website/accommodation-ui/helpers/calculatePercentageDiscount";
import { HasFilters } from "@website/accommodation-ui/helpers/hasFilters";
import { getPassengersAndRoomFromQuery, getPassengersCountAboveTwoYearsOld } from "@website/accommodation-ui/helpers/passengers";
import { useCreateDraft } from "@website/accommodation-ui/tour-card/tour-card-price/hooks";
import { TourCardPricePropertiesType } from "@website/accommodation-ui/tour-card/tour-card-price/types";
import { useJwtToken } from "@website/hooks/auth-manager";
import { addEventToDataLayer } from "@website/tracking/tracking.gtm";
import { DATA_LAYER_EVENTS, USER_TRACKING_EVENTS, WEBENGAGE_EVENTS } from "@website/tracking/tracking.types";
import { addEventToWebengage } from "@website/tracking/tracking.webengage";
import { addEventToTracking } from "@website/tracking/user";
import { Button } from "@website/ui/button";
import { MiniChips } from "@website/ui/mini-chips";
import { daysBetweenDates } from "@website/utils/date-format";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
import { useLoginModal } from "@website/widget/login";
import Link from "next/link";
import { useRouter } from "next/router";
import { FC } from "react";
export const TourCardPrice: FC<TourCardPricePropertiesType> = properties => {
  const $ = _c(137);
  const {
    tourIndex,
    pricing,
    hotel,
    departureFlight,
    returningFlight,
    supplier,
    webengageData,
    source,
    searchId,
    isDomestic,
    showPersonNumbers,
    dimBackground,
    flightRoomIndex,
    solutionId,
    noFollow
  } = properties;
  let t0;
  if ($[0] !== pricing) {
    t0 = pricing || {};
    $[0] = pricing;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    price,
    priceOff
  } = t0;
  let t1;
  if ($[2] !== hotel) {
    t1 = hotel || {};
    $[2] = hotel;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    name,
    stars,
    rooms
  } = t1;
  const router = useRouter();
  const {
    onLoginModalOpen
  } = useLoginModal();
  const {
    calendar_type,
    passengers: passengersParameter,
    dest,
    origin,
    id,
    stDate,
    rtDate,
    tour_position_rank,
    search_source
  } = router.query;
  const {
    phoneNumber
  } = useJwtToken();
  const t2 = passengersParameter as string;
  let t3;
  if ($[4] !== t2) {
    t3 = getPassengersAndRoomFromQuery(t2);
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    adults,
    child
  } = t3;
  const passengers = adults + child;
  const passengersAboveTwoYearsOldCount = getPassengersCountAboveTwoYearsOld(passengersParameter as string);
  const {
    mutate,
    isPending
  } = useCreateDraft(solutionId, id as string);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = OrderBy();
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    orderBy
  } = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = HasFilters();
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const {
    hasFilter,
    hasFilterRoom
  } = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = SolutionSource();
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const {
    solutionSource
  } = t6;
  let t7;
  if ($[9] !== calendar_type || $[10] !== departureFlight.airline || $[11] !== departureFlight.airlineName || $[12] !== departureFlight.arrivalDateTime || $[13] !== departureFlight.departureDateTime || $[14] !== departureFlight.destinationName || $[15] !== departureFlight.originName || $[16] !== dest || $[17] !== flightRoomIndex || $[18] !== hotel.id || $[19] !== hotel.name || $[20] !== hotel.rooms || $[21] !== hotel.stars || $[22] !== mutate || $[23] !== name || $[24] !== origin || $[25] !== passengers || $[26] !== phoneNumber || $[27] !== price || $[28] !== priceOff || $[29] !== pricing?.priceOff || $[30] !== returningFlight?.airline || $[31] !== returningFlight?.airlineName || $[32] !== returningFlight?.arrivalDateTime || $[33] !== returningFlight?.departureDateTime || $[34] !== rooms || $[35] !== rtDate || $[36] !== source || $[37] !== stDate || $[38] !== stars || $[39] !== supplier?.name || $[40] !== tour_position_rank || $[41] !== webengageData) {
    t7 = () => {
      mutate();
      addEventToDataLayer(DATA_LAYER_EVENTS.SELECT_ITEM, {
        items: [{
          item_name: hotel?.name,
          price: pricing?.priceOff,
          item_brand: "tour",
          item_category: calculateDifferencesNight(stDate as string, rtDate as string),
          item_category2: supplier?.name,
          item_category3: passengers,
          item_category4: Math.abs(daysBetweenDates(new Date(), stDate)),
          item_list_name: `تور ${departureFlight?.originName} به ${departureFlight?.destinationName}`,
          quantity: hotel?.rooms?.length
        }]
      });
      addEventToWebengage(WEBENGAGE_EVENTS.TOUR_ST_SELECT_SOLUTION, {
        ...webengageData,
        HotelName: name,
        HotelStars: stars,
        RoomType: rooms?.map?.(_temp).join("-"),
        OutboundFlightAirline: returningFlight?.airline,
        InboundFlightAirline: departureFlight?.airline,
        OutboundDepartureDate: returningFlight?.arrivalDateTime,
        InboundDepartureDate: departureFlight?.arrivalDateTime,
        ProviderDiscountNumber: Math.ceil(price - priceOff),
        TotalPrice: priceOff,
        UserPhoneNumber: phoneNumber,
        Source: source,
        HasFilter: hasFilter(),
        Sort: "",
        TourProvider: supplier?.name
      });
      addEventToTracking(USER_TRACKING_EVENTS.SOLUTION_SELECTED, {
        product: "tour",
        origin_city: origin as string,
        destination_city: dest as string,
        departure_date: new Date(departureFlight?.departureDateTime),
        arrival_date: new Date(departureFlight?.arrivalDateTime),
        return_departure_date: new Date(returningFlight?.departureDateTime),
        return_arrival_date: new Date(returningFlight?.arrivalDateTime),
        number_of_passengers: passengers,
        number_of_rooms: hotel?.rooms?.length,
        search_window: Math.abs(daysBetweenDates(new Date(), departureFlight?.departureDateTime)),
        hotel_id: hotel.id,
        hotel_name: hotel?.name,
        outbound_flight_airline: departureFlight?.airlineName,
        inbound_flight_airline: returningFlight?.airlineName,
        total_price: priceOff,
        tour_provider: supplier?.name,
        tour_sorting_option: orderBy,
        tour_has_filters: hasFilter(),
        hotel_stars: hotel.stars,
        calendar_type: calendar_type as string,
        select_solution_source: solutionSource,
        room_type: hotel?.rooms?.map(_temp2),
        flight_room_sorting_option: orderBy,
        flight_room_has_filters: hasFilterRoom(),
        tour_position_rank: Number(tour_position_rank),
        flight_room_position_rank: source === "RoomFlightPage" ? flightRoomIndex : undefined
      });
    };
    $[9] = calendar_type;
    $[10] = departureFlight.airline;
    $[11] = departureFlight.airlineName;
    $[12] = departureFlight.arrivalDateTime;
    $[13] = departureFlight.departureDateTime;
    $[14] = departureFlight.destinationName;
    $[15] = departureFlight.originName;
    $[16] = dest;
    $[17] = flightRoomIndex;
    $[18] = hotel.id;
    $[19] = hotel.name;
    $[20] = hotel.rooms;
    $[21] = hotel.stars;
    $[22] = mutate;
    $[23] = name;
    $[24] = origin;
    $[25] = passengers;
    $[26] = phoneNumber;
    $[27] = price;
    $[28] = priceOff;
    $[29] = pricing?.priceOff;
    $[30] = returningFlight?.airline;
    $[31] = returningFlight?.airlineName;
    $[32] = returningFlight?.arrivalDateTime;
    $[33] = returningFlight?.departureDateTime;
    $[34] = rooms;
    $[35] = rtDate;
    $[36] = source;
    $[37] = stDate;
    $[38] = stars;
    $[39] = supplier?.name;
    $[40] = tour_position_rank;
    $[41] = webengageData;
    $[42] = t7;
  } else {
    t7 = $[42];
  }
  const createBook = t7;
  let t8;
  if ($[43] !== createBook || $[44] !== onLoginModalOpen || $[45] !== phoneNumber) {
    t8 = () => {
      if (!phoneNumber) {
        return onLoginModalOpen().then(() => createBook());
      }
      return createBook();
    };
    $[43] = createBook;
    $[44] = onLoginModalOpen;
    $[45] = phoneNumber;
    $[46] = t8;
  } else {
    t8 = $[46];
  }
  const onReserve = t8;
  let t9;
  if ($[47] !== calendar_type || $[48] !== departureFlight.airline || $[49] !== departureFlight.arrivalDateTime || $[50] !== departureFlight.departureDateTime || $[51] !== dest || $[52] !== hotel.id || $[53] !== hotel.name || $[54] !== hotel.rooms || $[55] !== hotel.stars || $[56] !== name || $[57] !== origin || $[58] !== passengers || $[59] !== phoneNumber || $[60] !== price || $[61] !== priceOff || $[62] !== returningFlight?.airline || $[63] !== returningFlight?.arrivalDateTime || $[64] !== returningFlight?.departureDateTime || $[65] !== rooms || $[66] !== search_source || $[67] !== source || $[68] !== stars || $[69] !== supplier?.name || $[70] !== tourIndex || $[71] !== webengageData) {
    t9 = () => {
      addEventToDataLayer(DATA_LAYER_EVENTS.HOTEL_SUCCEED, {
        item_brand: "tour",
        item_name: `${origin} - ${dest}`,
        hotel_name: hotel?.name,
        hotel_star: hotel?.stars,
        destination_city: dest,
        departure_date: departureFlight?.departureDateTime,
        origin_city: origin,
        number_of_passengers: passengers,
        search_window: Math.abs(daysBetweenDates(new Date(), departureFlight?.departureDateTime)),
        return_date: returningFlight?.departureDateTime,
        search_source,
        nightstay: Math.abs(daysBetweenDates(returningFlight?.arrivalDateTime, departureFlight?.departureDateTime)),
        price
      });
      addEventToWebengage(WEBENGAGE_EVENTS.TOUR_ST_HOTEL_SELECTED, {
        ...webengageData,
        HotelName: name,
        HotelStars: stars,
        RoomType: rooms?.map?.(_temp3).join("-"),
        OutboundFlightAirline: returningFlight?.airline,
        InboundFlightAirline: departureFlight?.airline,
        OutboundDepartureDate: returningFlight?.arrivalDateTime,
        InboundDepartureDate: departureFlight?.arrivalDateTime,
        ProviderDiscountNumber: price - priceOff,
        TotalPrice: priceOff,
        UserPhoneNumber: phoneNumber,
        Source: source,
        HasFilter: hasFilter(),
        Sort: "",
        TourProvider: supplier?.name
      });
      addEventToTracking(USER_TRACKING_EVENTS.TOUR_HOTEL_SELECT_CLICKED, {
        product: "tour",
        origin_city: origin as string,
        destination_city: dest as string,
        departure_date: new Date(departureFlight?.departureDateTime),
        arrival_date: new Date(departureFlight?.arrivalDateTime),
        return_departure_date: new Date(returningFlight?.departureDateTime),
        return_arrival_date: new Date(returningFlight?.arrivalDateTime),
        number_of_passengers: passengers,
        number_of_rooms: hotel?.rooms?.length,
        search_window: Math.abs(daysBetweenDates(new Date(), departureFlight?.departureDateTime)),
        hotel_id: hotel.id,
        hotel_name: hotel?.name,
        outbound_flight_airline: departureFlight?.airline,
        inbound_flight_airline: returningFlight?.airline,
        total_price: priceOff,
        tour_provider: supplier?.name,
        tour_sorting_option: orderBy,
        tour_has_filters: hasFilter(),
        hotel_stars: hotel.stars,
        calendar_type: calendar_type as string,
        select_solution_source: solutionSource,
        room_type: hotel?.rooms?.map(_temp4),
        flight_room_sorting_option: orderBy,
        flight_room_has_filters: hasFilterRoom(),
        tour_position_rank: tourIndex
      });
    };
    $[47] = calendar_type;
    $[48] = departureFlight.airline;
    $[49] = departureFlight.arrivalDateTime;
    $[50] = departureFlight.departureDateTime;
    $[51] = dest;
    $[52] = hotel.id;
    $[53] = hotel.name;
    $[54] = hotel.rooms;
    $[55] = hotel.stars;
    $[56] = name;
    $[57] = origin;
    $[58] = passengers;
    $[59] = phoneNumber;
    $[60] = price;
    $[61] = priceOff;
    $[62] = returningFlight?.airline;
    $[63] = returningFlight?.arrivalDateTime;
    $[64] = returningFlight?.departureDateTime;
    $[65] = rooms;
    $[66] = search_source;
    $[67] = source;
    $[68] = stars;
    $[69] = supplier?.name;
    $[70] = tourIndex;
    $[71] = webengageData;
    $[72] = t9;
  } else {
    t9 = $[72];
  }
  const onVisitTour = t9;
  const priceDetailInfoText = departureFlight.transportType === "TRAIN" ? "\u0647\u062A\u0644+\u0642\u0637\u0627\u0631" : "\u0647\u062A\u0644+\u067E\u0631\u0648\u0627\u0632";
  let t10;
  if ($[73] !== priceDetailInfoText || $[74] !== showPersonNumbers || $[75] !== tour_position_rank) {
    t10 = showPersonNumbers ? <div className="text-caption text-on-surface-high-emphasis">قیمت{" "}{numberConvert(1, {
        locale: "fa"
      })}{" "}نفر{" "}<span className="max-md:text-overline">({tour_position_rank ? priceDetailInfoText : "\u0628\u0644\u06CC\u0637 + \u0627\u0642\u0627\u0645\u062A"})</span>{" "}از</div> : <p className="text-caption text-on-surface-high-emphasis">قیمت{" "}<span className="max-md:text-overline">({tour_position_rank ? priceDetailInfoText : "\u0628\u0644\u06CC\u0637 + \u0627\u0642\u0627\u0645\u062A"})</span></p>;
    $[73] = priceDetailInfoText;
    $[74] = showPersonNumbers;
    $[75] = tour_position_rank;
    $[76] = t10;
  } else {
    t10 = $[76];
  }
  let t11;
  if ($[77] !== passengersAboveTwoYearsOldCount || $[78] !== price || $[79] !== priceOff) {
    t11 = priceOff !== price && <div className="flex items-center justify-center md:pb-3"><div className="text-body-1 text-on-surface-disable me-1 line-through">{numberConvert(numberSeparator((price / (passengersAboveTwoYearsOldCount * 10)).toFixed(0)), {
          locale: "fa"
        })}</div>{Boolean(displayPercentageDiscount(price, priceOff)) && <MiniChips className="text-caption text-on-color-high-emphasis !px-2" color="primary" text={displayPercentageDiscount(price, priceOff) as string} variant="contained" />}</div>;
    $[77] = passengersAboveTwoYearsOldCount;
    $[78] = price;
    $[79] = priceOff;
    $[80] = t11;
  } else {
    t11 = $[80];
  }
  let t12;
  if ($[81] !== passengersAboveTwoYearsOldCount || $[82] !== price || $[83] !== priceOff) {
    t12 = numberConvert(numberSeparator(((priceOff || price) / (passengersAboveTwoYearsOldCount * 10)).toFixed(0)), {
      locale: "fa"
    });
    $[81] = passengersAboveTwoYearsOldCount;
    $[82] = price;
    $[83] = priceOff;
    $[84] = t12;
  } else {
    t12 = $[84];
  }
  let t13;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="text-subtitle-2 ms-1">تومان</div>;
    $[85] = t13;
  } else {
    t13 = $[85];
  }
  let t14;
  if ($[86] !== t12) {
    t14 = <div className="text-subtitle-1 text-on-surface-high-emphasis flex items-center justify-center">{t12}{t13}</div>;
    $[86] = t12;
    $[87] = t14;
  } else {
    t14 = $[87];
  }
  let t15;
  if ($[88] !== t11 || $[89] !== t14) {
    t15 = <div className="flex flex-col items-end gap-1">{t11}{t14}</div>;
    $[88] = t11;
    $[89] = t14;
    $[90] = t15;
  } else {
    t15 = $[90];
  }
  let t16;
  if ($[91] !== t10 || $[92] !== t15) {
    t16 = <div className="flex items-center justify-between md:flex-col md:gap-2 md:py-4 md:text-center">{t10}{t15}</div>;
    $[91] = t10;
    $[92] = t15;
    $[93] = t16;
  } else {
    t16 = $[93];
  }
  const t17 = `text-overline text-on-surface-high-emphasis flex items-center justify-between rounded-lg p-1 ${dimBackground && "bg-dim-background"}`;
  let t18;
  if ($[94] !== passengers) {
    t18 = numberConvert(passengers, {
      locale: "fa"
    });
    $[94] = passengers;
    $[95] = t18;
  } else {
    t18 = $[95];
  }
  let t19;
  if ($[96] !== t18) {
    t19 = <div>برای{" "}{t18}{" "}نفر{" "}</div>;
    $[96] = t18;
    $[97] = t19;
  } else {
    t19 = $[97];
  }
  let t20;
  if ($[98] !== price || $[99] !== priceOff) {
    t20 = numberConvert(numberSeparator(((priceOff || price) / 10).toFixed(0)), {
      locale: "fa"
    });
    $[98] = price;
    $[99] = priceOff;
    $[100] = t20;
  } else {
    t20 = $[100];
  }
  let t21;
  if ($[101] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <div className="text-overline ms-1">تومان</div>;
    $[101] = t21;
  } else {
    t21 = $[101];
  }
  let t22;
  if ($[102] !== t20) {
    t22 = <div className="text-body-2 md:text-caption flex items-center justify-center">{t20}{t21}</div>;
    $[102] = t20;
    $[103] = t22;
  } else {
    t22 = $[103];
  }
  let t23;
  if ($[104] !== t17 || $[105] !== t19 || $[106] !== t22) {
    t23 = <div className={t17}>{t19}{t22}</div>;
    $[104] = t17;
    $[105] = t19;
    $[106] = t22;
    $[107] = t23;
  } else {
    t23 = $[107];
  }
  let t24;
  if ($[108] !== t16 || $[109] !== t23) {
    t24 = <div className="flex flex-col justify-between pb-2 max-md:gap-2 md:grow">{t16}{t23}</div>;
    $[108] = t16;
    $[109] = t23;
    $[110] = t24;
  } else {
    t24 = $[110];
  }
  let t25;
  if ($[111] !== departureFlight.airline || $[112] !== departureFlight.departureDateTime || $[113] !== departureFlight.destinationName || $[114] !== departureFlight.originName || $[115] !== dest || $[116] !== hotel.id || $[117] !== hotel.name || $[118] !== hotel.stars || $[119] !== isDomestic || $[120] !== isPending || $[121] !== noFollow || $[122] !== onReserve || $[123] !== onVisitTour || $[124] !== origin || $[125] !== pricing?.price || $[126] !== returningFlight?.airline || $[127] !== returningFlight?.arrivalDateTime || $[128] !== router.query || $[129] !== searchId || $[130] !== source || $[131] !== supplier?.name || $[132] !== tourIndex) {
    t25 = <div className="flex gap-2 md:w-36 md:flex-col">{source === "RoomFlightPage" ? <Button fullWidth={true} loading={isPending} onClick={() => {
        onReserve();
        addEventToDataLayer(DATA_LAYER_EVENTS.SOLUTION_SELECT, {
          item_brand: "tour",
          item_name: `${origin} - ${dest}`,
          hotel_name: hotel?.name,
          hotel_star: hotel?.stars,
          departureairline: departureFlight?.airline,
          returnairline: returningFlight?.airline,
          provider: supplier?.name,
          destination_city: departureFlight?.destinationName,
          departure_date: departureFlight?.departureDateTime,
          origin_city: departureFlight?.originName,
          search_window: Math.abs(daysBetweenDates(new Date(), departureFlight?.departureDateTime)),
          return_date: returningFlight?.arrivalDateTime,
          nightstay: Math.abs(daysBetweenDates(returningFlight?.arrivalDateTime, departureFlight?.departureDateTime)),
          price: pricing?.price
        });
      }} size="small">مشاهده تور</Button> : <Link className="text-button bg-primary block w-full rounded-lg border px-4 py-2.5 text-center text-white" prefetch={false} href={{
        pathname: "/[origin]/[dest]/[id]",
        query: {
          ...router.query,
          id: searchId,
          hotelId: hotel?.id,
          isDomestic,
          tour_position_rank: tourIndex
        }
      }} onClick={onVisitTour} rel={noFollow ? "nofollow" : undefined}>مشاهده تورها{" "}</Link>}</div>;
    $[111] = departureFlight.airline;
    $[112] = departureFlight.departureDateTime;
    $[113] = departureFlight.destinationName;
    $[114] = departureFlight.originName;
    $[115] = dest;
    $[116] = hotel.id;
    $[117] = hotel.name;
    $[118] = hotel.stars;
    $[119] = isDomestic;
    $[120] = isPending;
    $[121] = noFollow;
    $[122] = onReserve;
    $[123] = onVisitTour;
    $[124] = origin;
    $[125] = pricing?.price;
    $[126] = returningFlight?.airline;
    $[127] = returningFlight?.arrivalDateTime;
    $[128] = router.query;
    $[129] = searchId;
    $[130] = source;
    $[131] = supplier?.name;
    $[132] = tourIndex;
    $[133] = t25;
  } else {
    t25 = $[133];
  }
  let t26;
  if ($[134] !== t24 || $[135] !== t25) {
    t26 = <div className="max-md:border-t-outline-thin h-full px-4 py-2 max-md:border-t md:flex md:flex-col md:justify-between md:py-4">{t24}{t25}</div>;
    $[134] = t24;
    $[135] = t25;
    $[136] = t26;
  } else {
    t26 = $[136];
  }
  return t26;
};
function _temp(room) {
  return room?.roomTitle;
}
function _temp2(room_0) {
  return room_0?.roomTitle;
}
function _temp3(room_1) {
  return room_1?.roomTitle;
}
function _temp4(room_2) {
  return room_2?.roomTitle;
}